module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "acitve-items"
  }, [_c('div', {
    staticClass: "active-items-title-read"
  }, [_c('div', {
    staticClass: "active-item-title on-show-two"
  }, [_vm._v(_vm._s(_vm.row.title))]), _vm._v(" "), _c('div', {
    staticClass: "active-imgs"
  }, _vm._l((3), function(item) {
    return _c('img', {
      attrs: {
        "src": require("../../assets/images/activity/pic-logo1@2x.png"),
        "alt": ""
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "active-itme-read"
  }, [_vm._l((_vm.row.cate_list), function(cate, i) {
    return _c('span', {
      key: i
    }, [_vm._v(_vm._s(cate.name))])
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.row.views_count) + "阅读")])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ebc4aa2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/news/NewsItem4.vue
// module id = 1443
// module chunks = 0